import { render, staticRenderFns } from "./InternationalFederationShow.vue?vue&type=template&id=39b93e74&"
import script from "./InternationalFederationShow.vue?vue&type=script&lang=js&"
export * from "./InternationalFederationShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports